<ng-template #addForm>
  <va-filter-container [showToolbar]="true" (searchTermChanged)="term$.next($event)">
    <div content>
      <div *ngFor="let user of users$ | async; let last = last">
        <div class="user-container">
          <div class="user-content-container">
            <div *ngIf="user.firstName || user.lastName" class="user-title">
              {{ user.firstName || '' | fullName : user.lastName || '' }}
            </div>
            <div class="user-subtitle">{{ user.email }}</div>
          </div>
          <mat-checkbox
            secondary-action-item
            [checked]="doesUserExist(user)"
            [disabled]="doesUserExist(user)"
            (change)="addUserToSelected($event, user)"
          ></mat-checkbox>
        </div>
      </div>
      <div *ngIf="loading$ | async" class="loading-spinner">
        <mat-spinner [diameter]="32" [strokeWidth]="4"></mat-spinner>
      </div>
      <div *ngIf="(users$ | async)?.length === 0 && (loading$ | async) === false" class="none-found">
        {{ 'ADD_USER_DIALOG_LIBRARY.NONE_FOUND' | translate }}
      </div>
    </div>
  </va-filter-container>
  <div class="table-footer">
    <button mat-flat-button *ngIf="hasMoreResults$ | async" (click)="loadMore()">
      {{ 'COMMON.ACTION_LABELS.LOAD_MORE' | translate }}
    </button>
  </div>
</ng-template>

<mat-dialog-content>
  <h2 mat-dialog-title>{{ 'ADD_USER_DIALOG_LIBRARY.ADD_USERS_TO_ACCOUNT' | translate }}</h2>
  <div class="content">
    <ng-container *ngIf="showCreateTab; else addForm">
      <mat-tab-group (selectedTabChange)="tabChanged($event)">
        <mat-tab label="{{ 'ADD_USER_DIALOG_LIBRARY.CREATE_USER' | translate }}">
          <div class="create-form-container">
            <users-create-user-form
              #createForm
              [accountGroupId]="accountGroupId"
              [partnerId]="partnerId"
              (userCreated)="userCreated($event)"
            ></users-create-user-form>
          </div>
        </mat-tab>
        <mat-tab label="{{ 'ADD_USER_DIALOG_LIBRARY.ADD_EXISTING_USER' | translate }}">
          <div>
            <ng-container *ngTemplateOutlet="addForm"></ng-container>
          </div>
        </mat-tab>
      </mat-tab-group>
    </ng-container>
  </div>
</mat-dialog-content>

<mat-dialog-actions [ngClass]="{ 'tertiary-button': !showCreateTab }">
  <ng-container *ngIf="!showCreateTab">
    <div class="left-actions">
      <button
        mat-flat-button
        color="primary"
        [disabled]="isLoading$ | async"
        (click)="dialogRef.close('create-new-user')"
      >
        {{ 'ADD_USER_DIALOG.CREATE_USER' | translate }}
      </button>
    </div>
  </ng-container>

  <div class="right-actions">
    <button mat-stroked-button color="secondary" mat-dialog-close [disabled]="isLoading$ | async">
      {{ 'ADD_USER_DIALOG_LIBRARY.CLOSE' | translate }}
    </button>

    <button
      mat-flat-button
      color="primary"
      (click)="onSubmit()"
      [disabled]="((tab$ | async) === UserAction.ADD && selectedUsers.length === 0) || (isLoading$ | async) === true"
    >
      <glxy-button-loading-indicator [isLoading]="(isLoading$ | async) === true">
        <ng-container *ngIf="(tab$ | async) === UserAction.ADD; else createButtonText">
          {{ 'ADD_USER_DIALOG_LIBRARY.ADD_USERS' | translate }}
        </ng-container>
        <ng-template #createButtonText>
          {{ 'ADD_USER_DIALOG_LIBRARY.CREATE_USER' | translate }}
        </ng-template>
      </glxy-button-loading-indicator>
    </button>
  </div>
</mat-dialog-actions>
